export default "__VITE_ASSET__CNiFsyg7__"